import { FC } from "react";
import { HStack, Text } from "@chakra-ui/react";

interface Props {
  code: string | undefined;
  bgColor: string;
}

export const ErrorTechInfoCode: FC<Props> = ({ code, bgColor }) => {
  const serviceCode = code?.slice(0, 2) || "";
  const errorCode = code?.slice(2, 5) || "";
  const resultCode = `${serviceCode} ${errorCode}`;

  if (!code) {
    return null;
  }

  return (
    <HStack
      spacing="10px"
      py="6px"
      px="10px"
      borderRadius="12px"
      bgColor={bgColor}
    >
      <Text fontSize="14px">Код</Text>
      <Text variant="brand">{resultCode}</Text>
    </HStack>
  );
};
